import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";

const BASE = END_POINT + "/api/ai-admin";

function getToken() {
  return localStorage.getItem("ai_admin_token");
}

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function logout() {
  localStorage.removeItem("ai_admin_token");
  window.location.href = "/login";
}

export async function loginApi(username, password) {
  const { data } = await axios.post(`${BASE}/login`, { username, password });
  if (data.token) {
    localStorage.setItem("ai_admin_token", data.token);
  }
  return data;
}

export async function fetchApi(path) {
  const { data } = await axios.get(`${BASE}${path}`, { headers: authHeaders() });
  return data;
}

export async function postApi(path, body) {
  const { data } = await axios.post(`${BASE}${path}`, body, { headers: authHeaders() });
  return data;
}

export async function putApi(path, body) {
  const { data } = await axios.put(`${BASE}${path}`, body, { headers: authHeaders() });
  return data;
}

export async function deleteApi(path) {
  const { data } = await axios.delete(`${BASE}${path}`, { headers: authHeaders() });
  return data;
}

export async function uploadApi(path, formData) {
  const { data } = await axios.post(`${BASE}${path}`, formData, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return data;
}
